import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProfile, patchUpdateProfile } from "redux/actions/SettingsAction";
import { Button, Grid } from "@mui/material";
import CommonForm from "components/commonForm/CommonForm";
import Loader from "components/loader/Loader";
import CommonCropImage from "components/commonCropImage/CommonCropImage";
import { updatedSettingsForm2, updatedSettingsForm3 } from "./SettingData";
import camera from "assets/images/camera.svg";
import profile from "assets/images/SubVendorLogo.svg";

function Settings() {
  const dispatch = useDispatch();
  const userProfileData = useSelector(
    (state) => state?.auth?.userProfile?.data
  );
  const loader = useSelector((state) => state?.auth?.loading);
  const [defaultValues, setDefaultValues] = useState({
    number: userProfileData?.mobile,
    email: userProfileData?.email,
  });
  const [value, setValue] = useState("account");
  const [image, setImage] = useState(
    userProfileData?.avatar?.url && userProfileData?.avatar != null
      ? userProfileData?.avatar?.url
      : null
  );
  const [imgError, setImgError] = useState("");
  const [fileTypeError, setFileTypeError] = useState("");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [imageObj, setImageObj] = useState({});
  const [dataLoaded, setDataLoaded] = useState(false);
  const [src, setSrc] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    dispatch(getProfile());
  }, []);

  useEffect(() => {
    if (userProfileData) {
      const defaultNewValues = {
        ...defaultValues,
        number: userProfileData?.mobile,
        email: userProfileData?.email,
      };
      setDefaultValues(defaultNewValues);
      setDataLoaded(true);
    }
  }, [userProfileData]);

  const onImageChange = (event) => {
    setFileTypeError("");
    if (event.target.files && event.target.files[0]) {
      const img = event.target.files[0];
      setImageObj(event.target.files[0]);
      const attributeType = ["image/jpeg", "image/png"];
      const allowedExtensions = ['jpeg', 'jpg', 'png'];

      const fileExtension = img.name.split('.').pop().toLowerCase();

      if (!attributeType.includes(img.type) || !allowedExtensions.includes(fileExtension)) {
        const typeError = "File type should be in png/jpg/jpeg";
        setFileTypeError(typeError);
      } else if (event.target.files[0].size > 1024000) {
        const errorVal = "Image size should not be more than 1 MB";
        setImgError(errorVal);
      } else {
        setFileTypeError("");
        setImgError('')
        setSrc(URL.createObjectURL(img));
        setModalOpen(true);
      }
      event.target.value = '';
    }
  };

  const handleErrorImg = (event) => {
    const typeError = "Please choose proper image";
    setFileTypeError(typeError);
    setModalOpen(false);
  };

  const handleCropSave = (blob, img) => {
    setImage(URL.createObjectURL(blob));
    let formData = new FormData();
    const file = new File([blob], imageObj?.name, { lastModified: new Date() });
    formData.append("avtar", file);
    dispatch(patchUpdateProfile(formData));
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  }

  return (
    <div>
      {loader ? (
        <Loader />
      ) : (
        <Grid container>
          <Grid item className="tabContainer" xs={12}>
            <Grid
              item
              md={6}
              container
              className="bgLightWhite p30"
              direction="column"
              justifyContent="flex-start"
            >
              <Grid className="dpTextStyle">Profile Picture</Grid>
              <Button
                variant="contained"
                component="label"
                className="uploadBtn"
              >
                <CommonCropImage
                  modalOpen={modalOpen}
                  src={src}
                  setModalOpen={setModalOpen}
                  handleCropSave={handleCropSave}
                  handleCloseModal={handleCloseModal}
                />
                <img
                  src={
                    image
                      ? image
                      : userProfileData?.avatar?.url
                      ? userProfileData?.avatar?.url
                      : profile
                  }
                  alt="profile"
                  className="imgFormSize"
                />
                {src && (
                  <img
                    src={src}
                    alt="profile"
                    className="imgFormSize displayNone"
                    onError={handleErrorImg}
                  />
                )}
                <div className="imgOuter">
                  <img src={camera} alt="camera" />
                </div>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => onImageChange(e)}
                  hidden
                />
              </Button>
              {imgError && imgError !== null && (
                <div className="errorMessage">{imgError}</div>
              )}
              {fileTypeError && fileTypeError !== null && (
                <div className="errorMessage">{fileTypeError} </div>
              )}
              {dataLoaded && (
                <>
                  <CommonForm
                    formData={updatedSettingsForm2}
                    defaultValues={defaultValues}
                  />
                  <CommonForm
                    formData={updatedSettingsForm3}
                    defaultValues={defaultValues}
                  />
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
      )}
    </div>
  );
}

export default Settings;
